import React, { useEffect } from 'react';
import './FooterContactList.scss';

/**
 * Renders the footer contact list. Due to Shopify limitations, this needs to be a separate component
 *
 * @param {string} title - the list title
 * @param {array} contactMenuGroup1 - the phone number fields
 * @param {array} contactMenuGroup2 - the Live chat fields
 * @param {array} contactMenuGroup3 - the email address fields (with label)
 * @returns {JSX.Element}
 * @constructor
 */
const FooterContactList = ({ title, contactMenuGroup1, contactMenuGroup2, contactMenuGroup3 }) => {
  let openBeacon;

  useEffect(() => {
    const beacon = document.querySelector('.c-beacon-button__button');

    openBeacon = () => {
      if (beacon) {
        if (beacon.classList.contains('is-hidden')) {
          beacon.classList.remove('is-hidden');
        }
      }

      Beacon('open');
    };
  });

  const renderMenuGroup = (group) =>
    group.map((item, i) => (
      <li key={`menu-group-${i}`} className="c-footer-contact-list__list-item body-2">
        {item.label && <p>{item.label}</p>}
        {item.beaconTrigger ? (
          <button
            className="c-footer-contact-list__list-item body-2 color-white c-footer-contact-list__beacon-trigger"
            onClick={() => openBeacon()}
          >
            {item.title}
          </button>
        ) : (
          <a className="color-white" href={item.url}>
            {item.title}
          </a>
        )}
      </li>
    ));

  return (
    <div className="c-footer-contact-list color-white">
      <div className="c-footer-contact-list__title-container eyebrow-2">
        <span className="c-footer-contact-list__title">{title}</span>
      </div>
      <div className="c-footer-contact-list__list-container">
        <ul className="c-footer-contact-list__list call">{renderMenuGroup(contactMenuGroup1)}</ul>
        <ul className="c-footer-contact-list__list chat">{renderMenuGroup(contactMenuGroup2)}</ul>
        <ul className="c-footer-contact-list__list email">{renderMenuGroup(contactMenuGroup3)}</ul>
      </div>
    </div>
  );
};

export default FooterContactList;
